import type { FormConfig } from "@amzn/aquila-feedback-web-assets";

import type { AquilaReportIssueTriggerType } from "../types/aquila";

import { zustandStore } from "./zustand.helpers";

interface ContextData {
    [key: string]: any;
}

export interface ApiErrorDetails {
    requestUrl?: string;
    requestPayload?: string;
    errorResponse?: string;
    errorCode?: string | number;
}

export interface ReportIssueActions {
    resetState: () => void;
    resetContextData: () => void;
    setReportIssueContextData: (contextData: ContextData) => void;
    updateReportIssueContextData: (newContextData: ContextData) => void;
    setFormConfig: (configId: string, formConfig: FormConfig) => void;
    openModal: (modalType: AquilaReportIssueTriggerType | null) => void;
    closeModal: () => void;
}

export interface ReportIssueState {
    formConfigMap: {
        [key: string]: FormConfig;
    };
    contextData: ContextData;
    activeModal: AquilaReportIssueTriggerType | null;
}

export const initialState: ReportIssueState = {
    formConfigMap: {},
    contextData: {},
    activeModal: null,
};

export const { store: reportIssueStore } = zustandStore<
    ReportIssueState,
    ReportIssueActions
>("reportIssue", initialState, (set, get) => ({
    setFormConfig: (configId: string, formConfig: FormConfig) => {
        const currentFormConfigMap = get().formConfigMap;
        const updatedFormConfigMap = {
            ...currentFormConfigMap,
            [configId]: formConfig,
        };
        set(() => ({ formConfigMap: updatedFormConfigMap }));
    },
    setReportIssueContextData: (contextData: ContextData) =>
        set(() => ({ contextData })),
    updateReportIssueContextData: (newContextData: ContextData) => {
        const currentContextData = get().contextData;
        set(() => ({
            contextData: { ...currentContextData, ...newContextData },
        }));
    },
    resetContextData: () => set(() => ({ contextData: {} })),
    resetState: () => set(() => ({ ...initialState, activeModal: null })),
    openModal: (modalType: AquilaReportIssueTriggerType | null) =>
        set(() => ({ activeModal: modalType })),
    closeModal: () =>
        set((state) => ({
            activeModal: null,
            contextData: {
                ...state.contextData,
                apiError: undefined,
            },
        })),
}));
